import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue'
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'
import mixx from "../../../mixin/mixin.js";
export default {
  mixins: [mixx],
  name: 'fd',
  data() {
    return {
      procesado: false,
      files: [],
      dropContainer: {},
      tabla: [],
      tipo: "1",
      loading: false,
    };
  },
  mounted() {
    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px");
    $(".box").boxWidget();
    this.dropContainer = document.getElementById("dropcontainer");
    this.fileInput = document.getElementById("images");
  },

  methods: {

    drop(e) {
      e.preventDefault(); this.dropContainer.classList.remove("drag-active");
      this.fileInput.files = e.dataTransfer.files;
      this.setFiles(1)
    },
    setFiles(st) {
      this.files = [];
      for (let i = 0; i < this.fileInput.files.length; i++) {
        this.files.push({ status: st, name: this.fileInput.files[i].name, detalle: "" });
      }

      this.procesado = false
    },
    inputDropArea() {
      this.setFiles(1)
    },
    dragover(e) {
      e.preventDefault()
    },
    cargar(i) {
      if (this.fileInput.files.length > i) {
        this.loading = true;
        let formData = new FormData();
        formData.append('file', this.fileInput.files[i]);
        this.$http
          .post(
            '/natura/creation',
            formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            responseType: 'blob'
          })

          .then((r) => {
            const href = URL.createObjectURL(r.data);
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', this.fileInput.files[i].name.split(".")[0] + "_resultado.csv");
            document.body.appendChild(link);
            link.click();

          }).catch(async (error) => {
            let responseObj = JSON.parse(await error.response.data.text())

            alert(responseObj.error)
          }).finally(() => {
            this.loading = false;
          })

      } else {
        alert("Seleccione 1 archivo en formato csv")
      }
    },
  },
  components: {
    barra,
    barrais,
    foot,
    barrade
  }
}



// WEBPACK FOOTER //
// ./src/components/configs/cargarNaturaCreation/index.js